export default "__VITE_ASSET__qgjym53n__"